import React from "react";
import { Button } from "@chakra-ui/react";
import { ButtonProps } from "../../utils/types/props.button";

const FormButton = ({
  children,
  type,
  variant,
  size,
  leftIcon,
  colorScheme,
  disabled,
  onClick,
  isLoading,
  style,
}: ButtonProps) => {
  return (
    <Button
      _hover={{ shadow: "lg" }}
      isLoading={isLoading}
      type={type}
      variant={variant}
      size={size}
      leftIcon={leftIcon}
      colorScheme={colorScheme}
      onClick={onClick}
      style={style ? style : { width: "100%" }}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default FormButton;
